import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { BodyText, TableBody, TableHead } from '@make-software/cspr-design';
import { SortingProps } from '../table-data-header/table-data-header';

export interface TableRenderProps {}

export interface TableSortingProps {
  sortingProps: SortingProps;
}

/* eslint-disable-next-line */
export interface TableProps {
  renderDataHeaders?: (renderProps: TableRenderProps) => ReactNode;
  renderData?: (renderProps: TableRenderProps) => ReactNode;
  renderHeader?: (renderProps: TableRenderProps) => ReactNode;
  renderFooter?: (renderProps: TableRenderProps) => ReactNode;
  paddingBottom?: number;
}

export const TableFooterContainer = styled.div<{
  padding?: Array<string>;
  hideBorder?: boolean;
}>(({ theme, hideBorder = false, padding = ['16px 0px'] }) =>
  theme.withMedia({
    overflowX: 'auto',
    margin: '0 20px',
    ...(padding && { padding: padding }),
    ...(!hideBorder && {
      borderTop: theme.border.tableRowSeparator,
    }),
  })
);

export const TableContainer = styled.div<{ paddingBottom?: number }>(
  ({ theme, paddingBottom }) => ({
    overflowX: 'auto',
    ...(paddingBottom && { paddingBottom }),
  })
);

const StyledTable = styled.table(({ theme }) => ({
  width: '100%',
  position: 'relative',
  borderCollapse: 'collapse',
}));

const NoDataContainer = styled.div(({ theme }) => ({
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export function Table(props: TableProps) {
  const {
    renderData,
    renderDataHeaders,
    renderHeader,
    renderFooter,
    paddingBottom,
  } = props;

  const renderProps = {
    // add renderProps here
  };

  return (
    <div>
      {renderHeader && renderHeader(renderProps)}
      <TableContainer paddingBottom={paddingBottom}>
        <StyledTable>
          {renderDataHeaders && (
            <TableHead>{renderDataHeaders(renderProps)}</TableHead>
          )}
          {renderData && <TableBody>{renderData(renderProps)}</TableBody>}
        </StyledTable>
      </TableContainer>
      {renderFooter && renderFooter(renderProps)}
    </div>
  );
}

export default Table;
